function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 1.5C0 0.671573 0.671573 0 1.5 0C2.32843 0 3 0.671573 3 1.5V9.5781L4.39436 9.12712C4.67708 8.29253 5.11363 7.57412 6.39707 7.57412C7.56446 7.57412 8.51095 8.47639 8.51095 9.64385L11.1804 11.6708C11.5998 11.0526 12.7663 11.1065 12.7663 11.1065L16.4689 6.37093C16.4689 6.37093 16.26 5.78304 16.26 5.45473C16.26 4.29008 17.2039 3.34632 18.3683 3.34632C19.5328 3.34632 20.4767 4.29005 20.4767 5.45473C20.4767 6.61907 19.5328 7.56295 18.3683 7.56295C18.2855 7.56295 18.2037 7.55815 18.1233 7.54889L14.3521 11.8778C14.6372 12.2454 14.8029 12.7171 14.8029 13.2316C14.8029 14.405 13.8516 15.3564 12.678 15.3564C11.5044 15.3564 10.5972 14.5153 10.5972 13.3419L7.89071 11.1825C7.50529 11.591 7.003 11.8019 6.39705 11.8019C5.61782 11.8019 4.93711 11.3805 4.57052 10.753L3 11.3506V16L19.5 16C20.3284 16 21 16.6716 21 17.5C21 18.3284 20.3284 19 19.5 19H1.5C0.671573 19 0 18.3284 0 17.5V1.5Z",
  fill: "black"
});

function SvgChange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.ef41b442.svg";
export { ForwardRef as ReactComponent };